<template>
  <f7-page id="page-sendmoney-enter-amount" name="sendmoney-enter-amount" @page:init="getExpressMapping();" @page:afterin="afterin();">
    <f7-navbar class="no-border view-mobile">
      <div class="navbar-inner">
        <f7-nav-left class="back-button">
          <f7-link icon-f7="chevron_left" @click="handleBackButton()" color="black"></f7-link>
        </f7-nav-left>
        <f7-nav-right>
          <f7-link></f7-link>
        </f7-nav-right>
      </div>
    </f7-navbar>

    <f7-block>
      <!-- ALERT MESSAGE -->
      <f7-card
        id     = "errorCard"
        class  = "alert mb-20"
        v-show = "alertCard.show"
        :class = "alertCard.alertClass"
        >
          <div v-html="alertCard.title" slot="header"></div>
          <i class="icon f7-icons card-close" @click="alertCard.show=false">xmark</i>
      </f7-card>

      <!-- PAGE TITLE -->
      <f7-row>
        <f7-col class="wandr-level-4">{{$t('sendmoney-enter-amount-page-title')}}</f7-col>
      </f7-row>
      <f7-row class="mt-lg">
        <f7-col class="b font-size-130">{{$t('sendmoney-text-recipient')}}</f7-col>
        <f7-col class="text-align-right pointer text-color-primary" @click="eventHandleEditBene()">{{$t('sendmoney-text-edit')}}</f7-col>
      </f7-row>

      <!-- BENEFICIARY CARD SECTION -->
      <div class="card card-20 beneficiary-card display-flex align-items-center justify-content-space-between">
        <div class="col-details">
          <div class="wandr-level-3">{{this.beneficiaryFirstName}}</div>
          <div class="wandr-caption-2" v-if="this.deliveryMethodId == 1 || this.deliveryMethodId == 6 || this.deliveryMethodId == 9">{{this.bankName}}({{this.bankAccountNo}})</div>
          <div class="wandr-caption-2" v-if="this.deliveryMethodId == 3">{{this.collectionAgent}}</div>
          <div class="wandr-caption-2" v-if="this.deliveryMethodId == 4">{{this.province}}&nbsp;&bull;&nbsp;{{this.city}}</div>
          <div class="wandr-caption-2" v-if="this.deliveryMethodId == 0">{{this.billingOrg}}&nbsp;&bull;&nbsp;{{this.bankAccountNo}}</div>
        </div>
        <div class="col-bank">
          <img :src="getBankImg(this.bankId)"/>
        </div>
      </div>

      <PhilGovDetailCard />

      <f7-row>
        <f7-col class="b font-size-130">{{$t('sendmoney-text-recipient-receives')}}</f7-col>
      </f7-row>
    </f7-block>

    <!-- FX CALCULATOR SECTION -->
    <f7-block class="card-container card-20">
      <f7-list class="form-group">
        <div class="mb-md text-color-gray b">
          {{$t('sendmoney-text-exchange-rate')}}
          <span v-if="activeRate.isReverse" class="text-color-black">1 {{homeCurrency}}  =  {{activeRate.bidRateDisplay}} {{hostCurrency}}</span>
          <span v-else class="text-color-black">1 {{hostCurrency}}  =  {{activeRate.bidRateDisplay}} {{homeCurrency}}</span>
        </div>

        <!-- HOST AMOUNT INPUT -->
        <f7-list-input
          input-id      ="input-host-amount"
          name          ="input-host-amount"
          type          ="text"
          class         ="amount fx-amount-row host-amount"
          :label        ="$t('sendmoney-label-you-send')"
          autocomplete  ="off"
          pattern       ="[0-9]*"
          inputmode     ="decimal"
          outline
          floating-label
          required
          :disabled     ="isAmountReadOnly"
          :value        ="hostObj.amount == 0 ? '' : hostObj.amount"
          @blur         ="hostObj.amount = $event.target.value; hostObj.tempAmount != $event.target.value ? calcFXRate($event.target.id) : '' ;"
          @focus        ="amountFocus($event.target.id); hostObj.tempAmount = hostObj.amount;"
          @keypress.native  ="$event.keyCode == 13 || $event.key.toUpperCase() === 'ENTER' ? (hostObj.amount = $event.target.value, $event.target.blur()) : ''"
          @keydown.native   ="preventInvalidNumericInput($event)"
          >
          <div slot="media" class="currency-code">
            <img :src="require('@/assets/img/flags/flag_rect_'+hostCountryId+'.png')" />
            {{hostCurrency}}
          </div>
        </f7-list-input>

        <!-- HOME AMOUNT INPUT -->
        <f7-list-input
          input-id      ="input-home-amount"
          name          ="input-home-amount"
          type          ="text"
          class         ="amount fx-amount-row mb-22"
          autocomplete  ="off"
          pattern       ="[0-9]*"
          inputmode     ="decimal"
          :label        ="$t('sendmoney-label-recipient-receives')"
          outline
          floating-label
          required
          :disabled     ="isAmountReadOnly"
          :value        ="homeObj.amount == 0 ? '' : homeObj.amount"
          @blur         ="homeObj.amount = $event.target.value; calcFXRate($event.target.id);"
          @focus        ="amountFocus($event.target.id);"
          @keypress.native  ="$event.keyCode == 13 || $event.key.toUpperCase() === 'ENTER' ? (homeObj.amount = $event.target.value, $event.target.blur()) : ''"
          @keydown.native   ="preventInvalidNumericInput($event)"
          >
          <div slot="media" class="currency-code">
            <img :src="require('@/assets/img/flags/flag_rect_'+homeCountryId+'.png')" />
            {{homeCurrency}}
          </div>
        </f7-list-input>
        <li v-show="showHomeRoundedUpAmt" class="mb-md">
          <span class="text-color-gray fs-12">{{$t('sendmoney-enter-amount-roundup-amount-note')}}</span>
        </li>

        <!-- PURPOSE OF PAYMENT DROPDOWN -->
        <f7-list-input
          input-id     ="paymentPurpose"
          id           ="paymentPurposeInput"
          name         ="paymentPurpose"
          class        ="clickable-row use-chevron mb-md"
          :label       ="$t('sendmoney-purpose-payment')"
          :placeholder ="$t('sendmoney-select-purpose-payment')"
          v-show       ="showPaymentPurpose"
          :value       ="paymentPurpose"
          :disabled    ="isMakePayment"
          @change      ="paymentPurposeId = $event.target.value;"
          outline
          floating-label
        >
          <f7-link popover-open=".popover-dropdown-tx-purpose" slot="content-start" class="clickable-item"></f7-link>
        </f7-list-input>
        <f7-popover id="dropdownPaymentPurpose" class="popover-dropdown-tx-purpose dropdown-default dropdown sendmoney" :backdrop="true">
          <f7-list>
            <f7-list-item popover-close link="#" v-for="item in paymentPurposeList" :key="item.key" :selected="item.key == paymentPurposeId" @click="eventChangePaymentPurpose($event.target,item.key);">
              {{item.value}}
            </f7-list-item>
          </f7-list>
        </f7-popover>

        <!-- PURPOSE OF PAYMENT OTHER -->
        <f7-list-input
          input-id     ="paymentPurposeOther"
          name         ="paymentPurposeOther"
          class        ="mb-md"
          type         ="text"
          :label       ="$t('sendmoney-purpose-payment-other')"
          v-show       ="showPaymentPurposeOther"
          :placeholder ="$t('beneficiary-other-payment-purpose')"
          :value       ="paymentPurposeOther"
          :disabled    ="isMakePayment"
          @input       ="paymentPurposeOther = $event.target.value; validateInput($event.target);"
          outline
          floating-label
        ></f7-list-input>

        <!-- PAYMENT METHOD DROPDOWN-->
        <f7-list-input
          input-id     ="paymentMethod"
          id           ="paymentMethodInput"
          name         ="paymentMethod"
          class        ="clickable-row use-chevron"
          :label       = "$t('sendmoney-label-payment-method')"
          :value       ="paymentMethod"
          @change      ="paymentMethodId = $event.target.value;"
          outline
          floating-label
        >
          <f7-link popover-open=".popover-payment-method" slot="content-start" class="clickable-item">
          </f7-link>
        </f7-list-input>

        <f7-popover id="dropdownPaymentMethod" class="popover-payment-method dropdown-with-image-1 dropdown sendmoney" :backdrop="true">
          <f7-list>
            <f7-list-item  popover-close link="#" v-for="pm in paymentMethodList" :key="pm.id" :value="pm.id"  @click="eventChangePaymentMethod(pm.id)">
              <div class="row align-items-center" style="-webkit-flex-wrap: nowrap;">
                <span class="fs-16">{{$t('sendmoney-pm-'+pm.id)}}</span>
                <img :src="require('@/assets/img/paymentmethod/pm_'+pm.id+'.png')" class="ml-sm"/>
              </div>
            </f7-list-item>
          </f7-list>
        </f7-popover>
      </f7-list>
    </f7-block>

    <f7-block>
      <PublicHolidayComponent :homeCountryId="this.$store.state.transaction.homeCountryId" :homeCountryName="this.$store.state.transaction.homeCountryName" />
    </f7-block>

    <f7-block>

      <!-- PAYMENT SUMMARY SECTION -->
      <div class="card card-20 payment-summary">
        <div class="mb-20 wandr-level-3">{{$t('sendmoney-text-payment-summary')}}</div>
        <div class="payment-details">
          <div>
            <div>{{$t('sendmoney-label-you-send')}}</div>
            <div>{{this.formatCurrency(hostObj.amountReal, 2) || 0}} {{hostCurrency}}</div>
          </div>
          <div>
            <div>{{$t('sendmoney-text-commision')}}
              <f7-link popover-open=".popover-commision-info" class="info">
                <i class="icon f7-icons color-green pl-sm" id="infoCommisionIcon">icon_info_circle</i>
              </f7-link>
            </div>
            <div>{{this.formatCurrency(commissionAmount, 2) || 0}} {{hostCurrency}}</div>
          </div>
          <div>
            <div>{{$t('sendmoney-text-convenience-fee')}}</div>
            <div>{{this.formatCurrency(convenienceTotalFees, 2) || 0}} {{hostCurrency}}</div>
          </div>
          <div v-if="discount.amount > 0">
            <div>{{$t('sendmoney-text-discount')}}</div>
            <div>-{{this.formatCurrency(discount.amount, 2) || 0}} {{hostCurrency}}</div>
          </div>
        </div>
        <div class="payment-total">
          <div class="wandr-level-3">{{$t('sendmoney-text-you-pay')}}</div>
          <div class="wandr-level-4">{{this.formatCurrency( ( parseFloat(totalAmountPayable) + parseFloat(convenienceTotalFees) ), 2) || 0}} {{hostCurrency}}</div>
        </div>
      </div>
      <f7-popover class="popover-commision-info info" :backdrop="true" :closeByBackdropClick="true" :closeByOutsideClick="true">
            <div class="fs-10 fw-medium">
              {{$t('sendmoney-text-commission')}}
            </div>
      </f7-popover>

      <!-- MESSAGE CONTENT -->
      <div class="text-align-center mt-20 mb-xl">
        <p class="text-color-green b">{{$t('sendmoney-rate-guarante', {PAYDATETIME: payDateTime})}}</p>
        <p v-html="$t(deliveryTimei18n, {number: deliveryTimeNumber})"></p>
      </div>

      <!-- APPLY COUPON SECTION -->
      <div v-if="!isMakePayment" class="card-container card-coupon pointer">
        <div class="row no-gap display-flex align-items-center" @click="sheetModal.applyCoupon.isOpen = true">
          <div class="col-90 display-flex align-items-center">
            <img :src="require('@/assets/img/icon/icon-discount.svg')" class="mr-sm">
            {{ this.isUseCoupon ? this.discount.amount + " " + hostCurrency + $t('sendmoney-text-offer-applied') : $t('sendmoney-text-apply-offer-code') }}
          </div>
          <div class="col-10 chevron right text-align-right" v-show="!this.isUseCoupon"></div>
          <div class="col-10 cancel-coupon" v-show="this.isUseCoupon" @click="handleCancelCoupon">{{$t('sendmoney-text-cancel')}}</div>
        </div>
      </div>

      <f7-card
        id     = "errorCard"
        class  = "alert mt-20"
        v-show = "couponErr.show"
        :class = "couponErr.alertClass"
        >
          <div v-html="couponErr.title" slot="header"></div>
          <i class="icon f7-icons card-close" @click="couponErr.show=false">xmark</i>
      </f7-card>

      <f7-sheet class="wandr-sheet-modal sheet-24"
        :opened="sheetModal.applyCoupon.isOpen"
        @sheet:closed="eventCouponSheetClosed()"
        :swipeToClose="true">
        <f7-list class="form-group">
          <f7-list-input
            input-id      ="couponCode"
            name          ="couponCode"
            type          ="text"
            class         ="coupon-code"
            :placeholder  ="$t('sendmoney-enter-offer-code')"
            label         =""
            autocomplete  ="off"
            :value        ="couponRedeemCode"
            @blur         ="couponRedeemCode = $event.target.value"
            @keypress.native  ="$event.keyCode == 13 || $event.key.toUpperCase() === 'ENTER' ? (couponRedeemCode = $event.target.value, $event.target.blur()) : ''"
            outline
          >
            <f7-link @click="handleValidateCouponCode" slot="content-end" class="redeem-link">
              {{$t('sendmoney-text-redeem')}}
            </f7-link>
          </f7-list-input>
        </f7-list>

        <div class="modal-subtitle mb-md mt-6">{{$t('sendmoney-text-offer-code')}}</div>
        <div>
          <div v-for="cp in couponList" :key="cp.code" class="coupon-list">
            <div v-if="cp.code == couponCode" class="coupon-applied">
              <div class="text-align-center">
                <img :src="require('@/assets/img/icon/icon-discount.svg')" >
              </div>
              <div class="text-align-center">{{$t('general-text-applied')}}</div>
            </div>
            <div v-else>
              <img :src="require('@/assets/img/icon/icon-coupon.svg')" >
            </div>
            <div>
              <div class="wandr-subtitle-2">{{cp.amount}} {{cp.currencyCode}} {{$t('sendmoney-text-offer')}}</div>
              <div class="text-color-gray">{{$t('sendmoney-text-valid-until')}} {{cp.validdate}}</div>
            </div>
            <div>
              <f7-link v-if="cp.code == couponCode" @click="handleCancelCoupon" class="cancel-coupon sheet-close">{{$t('sendmoney-text-cancel')}}</f7-link>
              <f7-link v-else @click="handleUseCoupon(cp)" class="sheet-close"> {{$t('sendmoney-text-use-now')}} </f7-link>
            </div>
          </div>
        </div>
      </f7-sheet>

      <f7-button class="mb-sm mt-xxl" :disabled="isFormInputValid ? false : true" large fill @click="btnHandleSendMoneyEnterAmountContinue()">
        {{$t('sendmoney-continue')}}
      </f7-button>
    </f7-block>

  </f7-page>
</template>

<script>
  import PhilGovDetailCard                from '@/components/beneficiary-philgov-detail-card'
  import PublicHolidayComponent           from '@/components/public-holiday'
  import { mapGetters, mapActions }       from "vuex";
  import { enforce,  fxRateHelper as FX } from '@/plugins/helper';

  export default{
    data(){
			return{
        activeRate                : { bidRate : 0, bidRateDisplay : "0", isReverse: false },
        alertCard                 : { show : false, title : "errror", content : "", alertClass:"alert-danger"},
        bankAccountNo             : 0,
        bankBranchId              : 0,
        bankExpressId             : 0,
        bankId                    : 0,
        bankName                  : "",
        bankTypeId                : 0,
        beneficiaryId             : 0,
        beneficiaryFirstName      : "",
        billingOrg                : "",
        charge                    : 0,
        checkWindow               : undefined,
        checkTimer                : null,
        cityId                    : 0,
        collectionAgentId         : 0,
        collectionAgent           : "",
        commissionAmount          : 0, // for charge.
        convenienceFee            : 0, // Based on Payment Method selected
        convenienceFeeByPercentage: 0, // Based on Payment Method selected
        convenienceTotalFees      : 0, // Based on Payment Method selected
        couponCode                : "",
        couponErr                 : { show : false, title : "errror", content : "", alertClass:"alert-danger"},
        couponRedeemCode          : "",
        couponList                : [],
        deliveryMethodId          : 1,
        deliveryMethodName        : "",
        deliveryTimei18n          : "",
        deliveryTimeList          : [],
        deliveryTimeNumber        : 0,
        discount                  : { amount : 0, originalAmount: 0, name : "", description : "" },
        expressAvailable          : false,
        expressService            : 0,
        fxRateCountryList         : [],
        fxRateObject              : { fxRateList: {}, fxRateSVList: {} },
        homeCountryId             : 99,
        homeCountryName           : "",
        homeCurrency              : "IDR",
        hostCountryId             : 189,
        hostCountryName           : "",
        hostCurrency              : "SGD",
        homeObj                   : { amount : "", amountReal : 0, isFocused  : false },
        hostObj                   : { amount : "", amountReal : 0, isFocused  : false, tempAmount : "" },
        isUseCoupon               : false,
        isExpressBankType         : false,
        isFormInputValid          : false,
        isMakePayment             : false,
        isSpecialCharge           : false,
        isAmountReadOnly          : false,
        isAmountValid             : false,
        isHomeAmountUnderMinimum  : false,
        isPaymentPurposeValid     : true,
        latestState               : "",
        maxOutstandingAmt         : 100001,
        maxTotalSendingAmount     : 100001,
        minHostAmount             : 0,
        minOutstandingAmt         : 0,
        payable                   : 0,
        payDateTime               : '',
        paymentMethodList         : [],
        paymentMethodId           : 0,
        paymentMethod             : "",
        paymentPurposeId          : 0,
        paymentPurpose            : "",
        paymentPurposeOther       : "",
        paymentPurposeList        : [],
        province                  : "",
        provinceId                : 0,
        p2hCustomerId             : 0,
        remittanceAmount          : 0,
        serviceId                 : 0,
        settlementId              : 0,
        sheetModal                : { applyCoupon: { isOpen: false, isInvalid: false } },
        showHomeRoundedUpAmt      : false,
        showPaymentPurpose        : true,
        showPaymentPurposeOther   : false,
        specialChargePercent      : 0,
        specialChargeMin          : 0,
        totalUnclearAmount        : 0,
        totalAmountPayable        : 0,
        transactionTypeId         : 0,
        transactionType           : "",
        treasuryReceiptAmountLimit: 100001,
        showPopUp                 :false,
        getMoreCommissionText     : "",
        minAmountForCommission    : 0,
			}
		},
    mounted(){
      // Required for everypage. Toggle desktop-view footer.
      this.toggleFooterVisibility(false)
      this.$f7.$('.page-content').on('scroll', (e) => {
        this.toggleFooterVisibility(e.target)
      })

      this.beneficiaryId              = this.$store.state.transaction.beneficiaryId
      this.beneficiaryFirstName       = this.$store.state.transaction.beneficiaryFirstName
      this.p2hCustomerId              = this.$store.state.transaction.p2hCustomerId
      this.bankAccountNo              = this.$store.state.transaction.bankAccountNo
      this.bankId                     = this.$store.state.transaction.bankId
      this.bankBranchId               = this.$store.state.transaction.bankBranchId
      this.bankName                   = this.$store.state.transaction.bankName
      this.homeCountryId              = this.$store.state.transaction.homeCountryId
      this.homeCountryName            = this.$store.state.transaction.homeCountryName
      this.homeCurrency               = this.$store.state.transaction.homeCurrency
      this.hostCountryId              = this.$store.state.transaction.hostCountryId
      this.hostCountryName            = this.$store.state.transaction.hostCountryName
      this.hostCurrency               = this.$store.state.transaction.hostCurrency
      this.deliveryMethodId           = this.$store.state.transaction.deliveryMethodId
      this.deliveryMethodName         = this.$store.state.transaction.deliveryMethodName
      this.provinceId                 = this.$store.state.transaction.provinceId
      this.province                   = this.$store.state.transaction.province
      this.cityId                     = this.$store.state.transaction.cityId
      this.city                       = this.$store.state.transaction.city
      this.paymentPurpose             = this.$store.state.transaction.paymentPurpose
      this.paymentPurposeOther        = this.$store.state.transaction.paymentPurposeOther
      this.paymentPurposeId           = this.$store.state.transaction.paymentPurposeId
      this.paymentMethod              = this.$store.state.transaction.paymentMethod
      this.paymentMethodId            = this.$store.state.transaction.paymentMethodId
      this.collectionAgentId          = this.$store.state.transaction.collectionAgentId
      this.collectionAgent            = this.$store.state.transaction.collectionAgent
      this.transactionTypeId          = this.$store.state.transaction.transactionTypeId
      this.transactionType            = this.$store.state.transaction.transactionType
      this.latestState                = this.$store.state.transaction.latestState
      this.billingOrg                 = this.$store.state.transaction.billingOrg
      this.hostObj.amount             = this.$store.state.transaction.hostAmountReal
      this.homeObj.amount             = this.$store.state.transaction.homeAmountReal
      this.commissionAmount           = this.$store.state.transaction.commissionAmount
      this.couponCode                 = this.$store.state.transaction.couponCode
      this.totalUnclearAmount         = this.$store.state.customer.totalUnclearAmount
      this.minOutstandingAmt          = this.$store.state.customer.minOutstandingAmt
      this.maxOutstandingAmt          = this.$store.state.customer.maxOutstandingAmt
      this.treasuryReceiptAmountLimit = ( this.$store.state.misc.appBranchId == process.env.VUE_APP_RETAIL_BRANCH_ID ) ?  this.$store.state.customer.treasuryReceiptAmountLimit : this.$store.state.customer.onlineTreasuryReceiptAmountLimit
      this.maxTotalSendingAmount      = this.maxOutstandingAmt - this.totalUnclearAmount;
      this.showPaymentPurpose         = (this.deliveryMethodId == 0) ? false : true

      this.isMakePayment              = this.$store.state.transaction.isMakePayment
      this.settlementId               = this.$store.state.transaction.settlementId
      this.bankTypeId                 = this.$store.state.transaction.bankTypeId

      this.serviceId                  = this.$store.state.transaction.serviceId
      this.expressService = 1
      this.expressAvailable = false;
      this.couponErr.show = false
      // Harcode check BASECURRENCY OTHER THAN 189 SGD for WandrE V1.0 to display AUD/NZD -> SGD
      this.activeRate.isReverse = (this.homeCountryId == 152 || this.homeCountryId == 13) ? true : false

      this.discount.amount            = this.$store.state.transaction.discountAmount
      this.discount.originalAmount    = this.$store.state.transaction.discountAmount

      if(isNaN(this.homeObj.amount)){
        this.$$('#input-host-amount').attr('type', 'text')
      }

      if(this.homeCountryId == 44){
        this.showHomeRoundedUpAmt = true
      }

      // IS PHILGOV ?
      if(this.bankId == 4520 || this.bankId == 4521 || this.bankId == 4522 ){
        this.isAmountReadOnly = true
        this.showPaymentPurpose = false
        this.showPaymentPurposeOther = false
      }

      if(this.isMakePayment){

        this.payDateTime = this.getMakeYourPaymentDate(this.$store.state.transaction.createdDateTime)
        this.isAmountReadOnly = true
        this.activeRate = {
          bidRate        : this.$store.state.transaction.exchangeRate,
          bidRateDisplay : FX.formatDisplayRate(this.$store.state.transaction.exchangeRate, {countryId: this.homeCountryId, isDisplay: true}),
          currencyId     : this.homeCountryId,
          isReverse      : (this.homeCountryId == 152 || this.homeCountryId == 13) ? true : false
        }

        this.hostObj.amountReal = this.hostObj.amount;
        this.homeObj.amountReal = this.homeObj.amount;
        this.hostObj.amount =  FX.formatCurrency(this.hostObj.amountReal, {isDisplay: true})
        this.homeObj.amount =  FX.formatCurrency(this.homeObj.amountReal, {countryId: this.activeRate.currencyId, isDisplay: true})

        this.calcPayment();
      }else{
        this.payDateTime = this.getMakeYourPaymentDate()
      }

      this.getMinHostAmount()
      this.getMinHostAmountForMoreCommission()
      this.getPurposeOfPayment()
      this.getHelpText(51, 0)
      this.getOnlineAdvisory(this.homeCountryId, 1)
      this.getDeliveryTime()
      this.renderDropdown()
		},
    components: {
      PhilGovDetailCard,
      PublicHolidayComponent
    },
		computed:{
			...mapGetters('auth', [
				'authenticating',
				'authenticationError',
				'authenticationErrorCode',
				'authenticationSuccess'
			])
		},
    destroyed() {
      if (window.checkoutCompleted) window.checkoutCompleted = null;
    },
    methods:{
      ...mapActions('auth', ['login']),

      afterin(){
        window.gtag('event', 'page_view', {page_title: 'Wandr-E [T] | '+this.$f7route.name, page_path: this.$f7route.path})
      },

      async renderDropdown(){
        const self    = this;
        const popover1 = ".sendmoney.popover-dropdown-tx-purpose";
        const popoverInner1 = ".sendmoney.popover-dropdown-tx-purpose .popover-inner";
        const popoverId1 = "dropdownPaymentPurpose";
        const inputId1 = "paymentPurpose";
        const inputListId1 = "#paymentPurposeInput";
        await self.setDropdownDirection(popover1, popoverInner1, popoverId1, inputId1, inputListId1)

        const popover2 = ".sendmoney.popover-payment-method";
        const popoverInner2 = ".sendmoney.popover-payment-method .popover-inner";
        const popoverId2 = "dropdownPaymentMethod";
        const inputId2 = "paymentMethod";
        const inputListId2 = "#paymentMethodInput";
        await self.setDropdownDirection(popover2, popoverInner2, popoverId2, inputId2, inputListId2)
        self.Dom7(".popover-commision-info.info").on('popover:open', function () {
            self.$$(".popover-commision-info.info").css({
                'visibility' : 'hidden',
            });
        });

        self.Dom7(".popover-commision-info.info").on('popover:opened', async function () {
            const parentPosTop = parseFloat(document.getElementById("infoCommisionIcon").getBoundingClientRect().top);
            const parentPosLeft = parseFloat(document.getElementById("infoCommisionIcon").getBoundingClientRect().left);

            var elHeight = parseFloat(self.$$(".popover-commision-info.info.modal-in").height());

            self.$$(".popover-commision-info.info.modal-in .popover-angle").css({
                'margin-left' : (-9.00 / 2) + 'rem', // 8rem = popover width, 1rem = 16px = margin
                'top' : (elHeight/2) + 'px',
                'transform' : 'rotate(90deg)'
            });

            self.$$(".popover-commision-info.info.modal-in").css({
                'visibility' : 'visible',
                'left' : (parentPosLeft+40) + 'px',
                'top' : (parentPosTop-16) + 'px'
            });

            // CLOSE POP-UP AFTER 3 SECONDS
            setTimeout(function(){
              self.$f7.popover.close('.popover-commision-info.info.modal-in')
            }, 3000);

        });

      },

      getExpressMapping(){
        const self = this;

        if( self.isMakePayment ){
          return ;
        }

        self.latestState = self.$store.state.transaction.latestState
        self.showPreloader()
        const txExpressMapping = this.$api.transaction.getExpressMapping(self.deliveryMethodId, self.bankId, self.homeCountryId, self.expressService)
        txExpressMapping.then(function(result){
          console.log(" txExpressMapping result", result)
          self.bankExpressId = result.bankId;
          var transactionData = self.$store.state.transaction;
          if(result.expressAvailable){
            transactionData.expressAvailable = 1
            self.expressAvailable = true
          }

          self.getCouponList()
          self.getFXRate()
        });
      },

      getFXRate(){
        const self = this;
        const fxRateListPromise    = this.$api.exchangeRate.getFXRateList(-1, 0, self.p2hCustomerId)
        const fxCountryListPromise = this.$api.exchangeRate.getFxCountryList()

        Promise.all([fxRateListPromise, fxCountryListPromise]).then((response)=>{
          const fxRateList    = response[0]
          const fxCountryList = response[1]

          this.$_.each(fxRateList, (fxRate) => {
            if(fxRate.currency == this.homeCurrency && fxRate.deliveryMethodId == this.deliveryMethodId){
              self.bankTypeId = fxRate.bankTypeId;
              var transactionData = this.$store.state.transaction;
              transactionData.bankTypeId = fxRate.bankTypeId;
              if(fxRate.bankTypeId == 2){
                self.isExpressBankType = true
                transactionData.isExpressBankType = 1
              }
            }
          })

          self.fxRateObject.fxRateList = FX.buildRateList(fxRateList)
          self.fxRateCountryList = FX.rearrageCountryList(fxCountryList, fxRateList)

          this.activeRate = this.populateActiveRate()
          this.calcFXRate()
        })
      },

      populateActiveRate(){
        let list = this.fxRateObject.fxRateList || {};
        let homeCountryDetails = {
          countryId : this.homeCountryId,
          dmId      : this.deliveryMethodId,
          bankTypeId: (this.isExpressBankType) ? 2 : 1
        }

        let newList = FX.getFxRateFromList(list, {countryId: 189}, homeCountryDetails)

        if ( newList !== undefined ) {
          if(newList.baseCurrencyIdOriginal != undefined && newList.baseCurrencyIdOriginal != 189){
            newList.bidRateDisplay = FX.formatDisplayRate(newList.bidRateOriginal, {countryId: this.homeCountryId, isDisplay: true})
          }else{
            newList.bidRateDisplay = FX.formatDisplayRate(newList.bidRate, {countryId: this.homeCountryId, isDisplay: true})
          }

          newList.isReverse = (this.homeCountryId == 152 || this.homeCountryId == 13) ? true : false

        }
        return newList;
      },

      calcFXRate(){
        const self = this

        self.hostObj.isFocused = false
        self.homeObj.isFocused = false
        let maxAmount = 1000000

        let isHost = ""
        let args = arguments
        if(typeof args[0] == 'string'){
          isHost = args[0] == 'input-host-amount' ? true : false ;
        } else if (typeof args[0] == 'boolean'){
          isHost = args[0]
          self.latestState = (isHost) ? "host" : "home"
        }

        if ( isHost || self.latestState == "host") {
          if(self.couponCode != ""){
            self.hostObj.amount = parseFloat(self.hostObj.amount.toString().replace(/,/g, ''))
          }

          self.hostObj.amount = enforce.maxLength(self.hostObj.amount, 10)
          self.hostObj.amount = enforce.maxAmount(self.hostObj.amount, maxAmount)

          self.hostObj.amountReal = FX.formatCurrency(parseFloat(self.hostObj.amount)) || 0
          self.homeObj.amountReal = FX.formatCurrency(self.hostObj.amountReal * self.activeRate.bidRate, {countryId: self.activeRate.currencyId})
        } else {

          if(self.couponCode != "" && self.latestState == "home"){
            self.homeObj.amount = parseFloat(self.homeObj.amount.toString().replace(/,/g, ''))
          }

          self.homeObj.amount = enforce.maxLength(self.homeObj.amount, 14)
          if((self.homeObj.amount / self.activeRate.bidRate) > maxAmount) {
            self.homeObj.amount = maxAmount * self.activeRate.bidRate;
          }

          self.homeObj.amountReal = FX.formatCurrency(parseFloat(self.homeObj.amount), {countryId: self.activeRate.currencyId}) || 0
          self.hostObj.amountReal = FX.formatCurrency(self.homeObj.amountReal / self.activeRate.bidRate)
        }

        //DO ROUNDING UP FOR CN DESTINATION COUNTRY
        if(self.homeCountryId == 44){
          self.homeObj.amountReal = FX.formatCurrency( Math.round(parseFloat(self.homeObj.amountReal)), {countryId: self.activeRate.currencyId}) || 0
          self.hostObj.amountReal = FX.formatCurrency(self.homeObj.amountReal / self.activeRate.bidRate)
        }

        self.formatAmount()
      },

      formatAmount(){
        const self = this;
        self.$$('.fx-amount-row input').attr('type', 'text')

        if(self.$f7.device.ios && typeof arguments[0] == 'string'){
          self.calcFXRate(arguments[0])
        }

        self.hostObj.amount = self.hostObj.amountReal == 0 ? "" : FX.formatCurrency(self.hostObj.amountReal, {isDisplay: true})
        self.homeObj.amount = self.homeObj.amountReal == 0 ? "" : FX.formatCurrency(self.homeObj.amountReal, {countryId: self.activeRate.currencyId, isDisplay: true})

        self.calcFees()
      },

      calcFees(){
        const self = this
        var bankIdUsed = ( self.expressAvailable ) ? self.bankExpressId : self.bankId

        const txSpecialChargePromise = this.$api.transaction.getSpecialCharge(self.deliveryMethodId, self.homeCountryId)
        const txChargePromise        = this.$api.transaction.getCharge(self.homeCountryId, self.deliveryMethodId, bankIdUsed, self.bankBranchId, self.homeCountryId,self.transactionTypeId, self.couponCode, self.provinceId, self.cityId, self.hostObj.amountReal)

        Promise.all([txSpecialChargePromise, txChargePromise]).then((response)=>{
          const txSpecialCharge = response[0]
          const txCharge        = response[1]

          if(txSpecialCharge.status == "2100" && txCharge.status == "1401"){
            const amountCharge = txCharge.result.amount;

            if(txSpecialCharge.result.minCharge > 0){
              self.isSpecialCharge      = true;
              self.specialChargePercent = txSpecialCharge.result.percentage;
              self.specialChargeMin     = txSpecialCharge.result.minCharge;
            }else{
              if(amountCharge > 0){
                self.charge = amountCharge;
              }else{
                self.charge = 0;
              }
            }

            if(self.isSpecialCharge){
              const percentageFees = (self.specialChargePercent / 100) * self.hostObj.amountReal;
              if(self.specialChargeMin > percentageFees){
                self.commissionAmount = (self.specialChargeMin).toFixed(2);
              }else{
                self.commissionAmount = (percentageFees).toFixed(2);
              }
            }else{
              self.commissionAmount   = (self.charge).toFixed(2);
            }

            if(self.couponCode.length > 0 ){
              self.validateCouponCode()
            }else{
              self.calcPayment()
            }

          }else{
            self.showErrorCard(self.$t('general-error-text', { zoholink:  process.env.VUE_APP_CUSTOMER_SERVICE_ZOHO_LINK}) )
            self.hidePreloader();
          }

        })
      },

      calcPayment(){
        this.showPreloader()
        if(this.$$("#input-host-amount").is(':focus')){
          this.amountFocus('input-host-amount')
        }

        if(this.$$("#input-home-amount").is(':focus')){
          this.amountFocus('input-home-amount')
        }
        var discountVal_ = 0

        if(this.discount.amount > 0){
          if(this.discount.originalAmount > parseFloat(this.hostObj.amountReal)){
            discountVal_ = parseFloat(this.hostObj.amountReal)
            this.discount.amount = discountVal_
          }else{
            discountVal_ = this.discount.originalAmount
          }
        }

        this.remittanceAmount     = parseFloat(this.hostObj.amountReal)
        this.totalAmountPayable   = ( (parseFloat(this.hostObj.amountReal) - parseFloat(discountVal_) ) + parseFloat(this.commissionAmount)).toFixed(2);

        this.getPaymentMethod()
        this.isFormInputValid = false;
        this.isAmountValid    = true;
        this.setInputState("input-host-amount", true)
        this.setInputState("input-home-amount",true)

        if(this.remittanceAmount >= this.minHostAmount){
          if(parseFloat(this.remittanceAmount) > parseFloat(this.treasuryReceiptAmountLimit)){
            this.setInputState( "input-host-amount", this.$t('sendmoney-limit-amount-alert-content-1', { zoholink:  process.env.VUE_APP_CUSTOMER_SERVICE_ZOHO_LINK,  currency: this.hostCurrency, amount: this.formatCurrency(this.treasuryReceiptAmountLimit, 2)}) )
            this.isFormInputValid = false
            this.isAmountValid    = false
          }else{
            if(this.remittanceAmount > parseFloat(this.maxTotalSendingAmount)){
              this.setInputState("input-host-amount", this.$t('sendmoney-limit-amount-alert-content-2', {zoholink: process.env.VUE_APP_CUSTOMER_SERVICE_ZOHO_LINK}))
              this.isFormInputValid = false
              this.isAmountValid    = false
            }else{
              this.validateHomeAmountOverlimit()
            }
          }
        }else{

          if(this.remittanceAmount > 0 && this.remittanceAmount < this.minHostAmount){
            this.isAmountValid  = false
            this.setInputState("input-host-amount", this.$t( (this.bankId == 4521 && this.bankBranchId == 619401 ) ?  'sendmoney-enter-amount-min-amount-phil-gov-txt' : 'sendmoney-enter-amount-min-amount' , {currency: this.hostCurrency, amount: this.formatCurrency(this.minHostAmount, 2)}))
          }else{
            this.alertCard.show = false
          }
        }

        if (this.remittanceAmount > 0 && this.validateHomeAmountUnderMinimum()) {
          this.isHomeAmountUnderMinimum = true
          this.isFormInputValid = false
          this.isAmountValid    = false
        } else {
          this.isHomeAmountUnderMinimum = false
        }

        this.populateDeliveryTime();
        this.hidePreloader()
      },

      amountFocus(thisDOMId){
        let isHost         = thisDOMId == 'input-host-amount' ? true : false ;
        let $thisInput     = this.$$('#'+thisDOMId);
        if( isHost ){
          this.setLatestState('host')
          this.latestState = "host";
          this.hostObj.isFocused = true;
          this.homeObj.isFocused = false;
          this.hostObj.amount = this.hostObj.amountReal == 0 ? "" : this.hostObj.amountReal

        } else {
          this.setLatestState('home')
          this.latestState = "home";
          this.homeObj.isFocused = true;
          this.hostObj.isFocused = false;
          this.homeObj.amount = this.homeObj.amountReal == 0 ? "" : this.homeObj.amountReal
        }

        $thisInput.attr('type', 'number');

        this.isFormInputValid = false;
      },

      dismissOnlineAdvisory(){
        this.showPopUp=false
      },

      //PAYMENT PURPOSE
      async getPurposeOfPayment(){
        const self = this;
        let gender = self.$store.state.customer.gender
        if(gender.length<=0 || gender=== undefined){
          gender ="M"
        }
        
        let beneTypeId =self.$store.state.beneficiary.beneficiaryTypeId
        let isFoundInList       = false
        const purposePromise    = await this.$api.beneficiary.getPaymentPurposeList(this.homeCountryId,gender, beneTypeId)
        const ppList            = purposePromise
        self.paymentPurposeList = []
        Object.keys(ppList).forEach(key => {
          if(self.paymentPurpose == ppList[key]){
            self.paymentPurposeId = key
            isFoundInList = true
          }

          self.paymentPurposeList.push({key: key, value: ppList[key]})
        })

        // NOT INDIA
        if(this.homeCountryId != 98) {
          self.paymentPurposeList.push({key: -1, value: "Other"})
        }

        if( self.paymentPurpose != undefined && self.paymentPurpose.length > 0 && !isFoundInList && self.showPaymentPurpose){
          self.paymentPurposeOther     = (self.paymentPurposeOther.length > 0) ? self.paymentPurposeOther : self.paymentPurpose
          self.showPaymentPurposeOther = true
          self.paymentPurpose          = "Other"
          self.paymentPurposeId        = -1
        }

        if(self.bankId == 4520 || self.bankId == 4521 || self.bankId == 4522 ){
          self.showPaymentPurpose = false
          self.showPaymentPurposeOther = false
        }

      },

      eventChangePaymentPurpose(inputEl, ppId){
        this.setInputState("paymentPurpose",      true)
        this.setInputState("paymentPurposeOther", true)
        for(let i=0; i < this.paymentPurposeList.length; i++) {
          let thisPP = this.paymentPurposeList[i]
          if(thisPP.key == ppId) {
            this.paymentPurposeId        = ppId
            this.paymentPurpose          = thisPP.value
            this.showPaymentPurposeOther = (ppId < 0) ? true : false
            this.validateInput(inputEl)
            break;
          }
        }
      },

      getPaymentMethod(){
        const self = this
        const txPaymentMethod = this.$api.transaction.getPaymentMethodList(self.totalAmountPayable)

        txPaymentMethod.then(function(result) {
          self.paymentMethodList = [];
          Object.keys(result).forEach(function(key) {
            var val = result[key];
            var item =[];
            item["id"]              = key
            item["name"]            = val.name
            item["fee"]             = val.fee
            item["feeByPercentage"] = val.feeByPercentage
            item["totalPayable"]    = val.totalAmountPayable
            item["totalFee"]        = val.totalFee
            item["priority"]        = val.priority

            self.paymentMethodList.push(item)
            if(self.paymentMethodId == key){
              self.paymentMethod   = self.$t('sendmoney-pm-'+ key)
              self.paymentMethodId = key
              self.convenienceFee  = val.fee
              self.convenienceFeeByPercentage = val.feeByPercentage
              self.convenienceTotalFees = val.totalFee
              self.validatePaymentMethod()
            }

          })
          self.paymentMethodList = self.paymentMethodList.sort((a,b)=> a.priority - b.priority)
        })
      },

      eventChangePaymentMethod(pmId){
        this.paymentMethodId = pmId
        this.setInputState("paymentMethod", true)
        this.getPaymentMethod()
      },

      // COUPON
      getCouponList(){
        const self = this;
        const couponDiscount = this.$api.transaction.getDiscountList(self.homeCountryId)
        self.couponList = []
        couponDiscount.then(function(result){
          if(result.length > 0){
            Object.keys(result).forEach(function(key) {
              var val = result[key]
              var coupon  = []
              coupon["code"] = val.couponCode
              coupon["currencyCode"] = val.discount.currencyCode
              coupon["percent"] = val.discount.percent
              coupon["amount"] = val.discount.value
              coupon["discountCampaignDescription"] = val.discountCampaignDescription
              coupon["discountCampaignName"] = val.discountCampaignName
              coupon["validdate"] = self.getDateFormat(val.endDate, false)
              self.couponList.push(coupon)
            })
          }
        })
      },

      handleValidateCouponCode(){
        this.showPreloader()
        if(this.couponRedeemCode != ""){
          this.couponCode = this.couponRedeemCode.trim();
          this.validateCouponCode()
        }else{
          this.hidePreloader()
        }
      },

      handleUseCoupon(coupon){
        this.showPreloader()
        this.couponCode = coupon.code
        this.validateCouponCode()
      },

      handleCancelCoupon(){
        this.discount    = { amount : 0, originalAmount:0, name : "", description : "" }
        this.couponErr.show =false
        this.couponCode  = ''
        this.isUseCoupon = false
        this.calcPayment()
      },

      validateCouponCode(){
        const self = this
        const txDiscount =  this.$api.transaction.getDiscount( self.transactionTypeId, self.homeCountryId, self.homeCountryId, self.hostCountryId, self.commissionAmount, self.couponCode, self.deliveryMethodId, self.bankTypeId, self.hostObj.amountReal);
        txDiscount.then(function(result) {
          self.isUseCoupon = false
          self.discount    = { amount : 0, originalAmount: 0, name : "", description : "" }
          self.couponErr   = { show : false, title : "errror"}

          if(result == 1608){ // coupon invalid
            self.populateValidateCouponErrMsg(self.$t('sendmoney-coupon-expired'))
          }else{
            if(result.status == "1605"){
              self.isUseCoupon     = true
              self.discount.amount = parseFloat(result.result.value);
              self.discount.originalAmount = parseFloat(result.result.value);
              self.discount.name   = result.result.discountCampaignName;
              self.discount.description = result.result.discountCampaignDescription;
              self.setInputState('couponCode', true);
              self.calcPayment()
            }else if(result.status == "1608"){
              self.populateValidateCouponErrMsg(self.$t('sendmoney-coupon-expired'))
            }else{
              var errMsg = ( result.message.length > 0 ) ? result.message : self.$t('general-error-text', { zoholink:  process.env.VUE_APP_CUSTOMER_SERVICE_ZOHO_LINK})
              self.populateValidateCouponErrMsg(errMsg)
            }
          }
        });
      },

      populateValidateCouponErrMsg(errMsg){
        const self = this
        self.couponCode  = ''
        self.sheetModal.applyCoupon.isInvalid = true
        if(self.couponRedeemCode.length > 0){
          self.setInputState('couponCode', errMsg)
        }else{
          self.couponErr.title      = errMsg
          self.couponErr.alertClass = 'alert-danger'
          self.couponErr.show       = true
        }
        self.calcPayment()
      },

      eventCouponSheetClosed(){
        if(this.sheetModal.applyCoupon.isInvalid){
          this.setInputState('couponCode', true);
          this.couponRedeemCode = "";
          this.couponCode       = "";
        }
        this.sheetModal.applyCoupon.isOpen = false
      },
      // END COUPON

      setLatestState(st){
        const self = this;
        var transactionData = self.$store.state.transaction;
        transactionData.latestState = st;
      },

      validateInput(inputEl){
        let isValidInput = false;
        if(inputEl.id == "paymentPurpose" || inputEl.id == "paymentPurposeOther") { // PAYMENT PURPOSE
          if(this.paymentPurposeId > 0 || this.paymentPurposeId == -1){
            isValidInput = this.validatePaymentPurpose()
          }
        }else {
          isValidInput = true
        }

        this.isPaymentPurposeValid = isValidInput
        this.isFormInputValid = ( this.isAmountValid ) ? isValidInput : false;
      },

      validatePaymentMethod(){
        let pmId = this.paymentMethodId
        let isValidInput = false

        if(pmId <= 0){
          this.setInputState("paymentMethod", "Please select payment method")
          isValidInput =  false
        }else{
          this.setInputState("paymentMethod", true)
          isValidInput =  true
        }

        return isValidInput
      },

      validatePaymentPurpose(){
        let ppId         = this.paymentPurposeId;
        let isValidInput = false;
        let $$           = this.Dom7;

        if(!this.showPaymentPurpose){
          return true
        }

        isValidInput = ppId > 0 || ppId == -1;
        let inputState = isValidInput ? true : this.$t('beneficiary-payment-purpose-error');
        this.setInputState("paymentPurpose", inputState);
        if(ppId == -1) {
          this.showPaymentPurposeOther = true;
          $$('select[name="paymentPurpose"]').closest('li').addClass('mb-0');
          isValidInput = this.validateOtherPaymentPurpose();
        } else {
          this.showPaymentPurposeOther = false;
          $$('select[name="paymentPurpose"]').closest('li').removeClass('mb-0');
        }

        return isValidInput;
      },

      validateOtherPaymentPurpose() {
        let notes        = this.paymentPurposeOther;
        let isValidInput = false;
        let inputState   = "";
        let chkSpcResult = this.checkPreventOnlySpecial(notes);

        if(chkSpcResult < 0) {
          isValidInput = false;
          switch(chkSpcResult) {
            case -1:
              inputState = isValidInput ? true : this.$t('beneficiary-payment-purpose-error');
              this.setInputState("paymentPurposeOther", inputState);
              break;
            case -2:
              inputState = isValidInput ? true : this.$t('beneficiary-payment-purpose-error2');
              this.setInputState("paymentPurposeOther", inputState);
              break;
            case -3:
              inputState = isValidInput ? true : this.$t('beneficiary-payment-purpose-error3');
              this.setInputState("paymentPurposeOther", inputState);
              break;
          }
        } else {
          isValidInput = true;
          this.setInputState("paymentPurposeOther", true);
        }
        return isValidInput;
      },

      validateHomeAmountOverlimit(){
        const self = this
        let isOverLimit = false
        let maxOverLimitAmount = 0
        let homeAmount = parseFloat(self.homeObj.amountReal)

        if(self.deliveryMethodId == 1 || self.deliveryMethodId == 9 ){
          if(self.homeCountryId == 98 && self.expressAvailable == 1 &&  homeAmount > 200000 ){
            maxOverLimitAmount = 200000
            isOverLimit = true
          }
        }

        if(self.deliveryMethodId == 3){
          if(self.homeCountryId == 167 && ( self.collectionAgentId  == 1105 || self.collectionAgentId  == 3713 ) && homeAmount > 50000 ){
            maxOverLimitAmount = 50000
            isOverLimit = true
          }else if(self.homeCountryId == 167 && self.collectionAgentId  == 2200 && homeAmount > 20000 ){
            maxOverLimitAmount = 20000
            isOverLimit = true
          }
        }

        if(isOverLimit){
          self.setInputState("input-home-amount", self.$t('sendmoney-limit-amount-alert-content', {currency:self.homeCurrency, amount: self.formatCurrency(maxOverLimitAmount, 2)}))
          self.isFormInputValid = false
          this.isAmountValid    = false
        }else if(self.deliveryMethodId != 0){
          var bankIdUsed = ( self.expressAvailable ) ? self.bankExpressId : self.bankId
          const checkRoutingPromise = self.$api.transaction.checkingRouting(bankIdUsed, self.beneficiaryId,parseFloat(self.homeObj.amountReal))
          checkRoutingPromise.then(function(result) {
            console.log("checkRoutingPromise result ", result)
            if(result.status == '0129'){
              isOverLimit = false
              self.alertCard.show = false
            }else if(result.status == '0527'){
              self.setInputState("input-home-amount", self.$t( "sendmoney-limit-home-amount-alert-content", {message: result.message}))
              isOverLimit = true
            }else{
              self.setInputState("input-home-amount", result.message)
              isOverLimit = true
            }

            self.isFormInputValid = ( self.isPaymentPurposeValid ) ? !isOverLimit && !self.isHomeAmountUnderMinimum : false
            self.isAmountValid    = !isOverLimit && !self.isHomeAmountUnderMinimum
          })
        }else{
          self.isFormInputValid = (self.isPaymentPurposeValid) ? true : false
          self.alertCard.show   = false
        }

      },

      validateHomeAmountUnderMinimum(){
        const self = this
        let isUnderMinimum = false
        let minimumAmount = 0
        let homeAmount = parseFloat(self.homeObj.amountReal)

        if(self.deliveryMethodId == 1){
          if(self.homeCountryId == 111 && homeAmount < 30000 ){ // South Korea
            minimumAmount = 30000
            isUnderMinimum = true
          }
        }

        if(isUnderMinimum){
          self.setInputState("input-home-amount", self.$t('sendmoney-enter-amount-min-amount', {currency:this.homeCurrency, amount: this.formatCurrency(minimumAmount, 2)}))
        }

        return isUnderMinimum
      },

      eventHandleEditBene(){
        const self = this
        var beneficiaryData               = self.$store.state.beneficiary;
        beneficiaryData.beneficiaryId     = self.beneficiaryId;
        beneficiaryData.homeCountryId     = self.homeCountryId
        beneficiaryData.transactionTypeId = self.transactionTypeId
        beneficiaryData.deliveryMethodId  = self.deliveryMethodId
        beneficiaryData.bankId            = self.bankId
        beneficiaryData.isCreateBeneficiary  = false

        self.hidePreloader()
        self.$f7router.navigate("/beneficiary-modify");
      },

      showErrorCard(errorMessage) {
        this.alertCard.title      = errorMessage
        this.alertCard.alertClass = 'alert-danger'
        this.alertCard.show       = true
      },

      formatCurrency(num, dec) {
        let val = (Math.round((parseFloat(num) + Number.EPSILON) * 100) / 100).toFixed(dec)
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      },

      round(num, dec) {
        return parseFloat(Math.round((num + Number.EPSILON) * 100) / 100).toFixed(dec);
      },

      getMinHostAmount(){
        const self = this;
        const txMinHostAmount = this.$api.transaction.getMinHostAmount();

        txMinHostAmount.then(function(result) {
          self.minHostAmount = result.amount
        });
      },

      getMinHostAmountForMoreCommission(){
        const self = this;
        const destCountryId = self.homeCountryId;
        let txMinAmount = 0;

        // 13 - AUSTRALIA | 152 - NEW ZEALAND
        if(destCountryId == 13 || destCountryId == 152){
          txMinAmount = 500
        }
        // 208 - THAILAND
        else if(destCountryId == 208){
          txMinAmount = 500
        }
        // 98 - INDIA
        else if(destCountryId == 98){
          // 3 - COLLECTION
          if(self.deliveryMethodId == 3){
            txMinAmount = 500
          }
          // 1 - BANK TRANSFER | 9 - UPI
          else if(self.deliveryMethodId == 1 || self.deliveryMethodId == 9){
            txMinAmount = 500
          }
        }
        // 99 - INDONESIA
        else if(destCountryId == 99){
          txMinAmount = 500
        }
        // 167 - PHILIPPINES
        else if(destCountryId == 167){
          // 3 - COLLECTION
          if(self.deliveryMethodId == 3){
            txMinAmount = 500
          }
          // 0 - BILL PAYMENT | 1 - BANK TRANSFER | 6 - CASH CARD | 7 - WALLET
          else if(self.deliveryMethodId == 0 || self.deliveryMethodId == 1 || self.deliveryMethodId == 6 || self.deliveryMethodId == 7){
            txMinAmount = 500
          }
        }
        // 106 - JAPAN
        else if(destCountryId == 106){
          txMinAmount = 500
        }
        // 111 - S. KOREA || 95 - HONG KONG
        else if(destCountryId == 111 || destCountryId == 95){
          txMinAmount = 500
        }
        // 197 - SRI LANKA
        else if(destCountryId == 197){
          txMinAmount = 500
        }
        //Malaysia
        else if(destCountryId==128){
          txMinAmount = 500
        }
        //Vietnam
        else if(destCountryId==228){
          txMinAmount = 500
        }
        //China || Taiwan
        else if(destCountryId==44 || destCountryId == 205){
          txMinAmount = 1500
        }
        //United Kingdom (UK)
        else if(destCountryId==221){
          txMinAmount = 500
        }
        //United State (USA)
        else if(destCountryId==253){
          txMinAmount = 500
        }
        //European Union (EU)
        else if(destCountryId==238){
          txMinAmount = 500
        }
        self.minAmountForCommission = txMinAmount
        txMinAmount = self.formatCurrency(txMinAmount, 2)

        let tmpDestinationName = self.homeCountryName;
        if(destCountryId==253){ // USA -> country name returned by API = "America"
          tmpDestinationName = "the United States";
        }else if(destCountryId==238){ // EU -> country name returned by API = "European Union (EU)"
          tmpDestinationName = "EU";
        }else if(destCountryId==167 || destCountryId==221){ // Philippines || United Kingdom (UK)
          tmpDestinationName = "the "+self.homeCountryName;
        }
        self.getMoreCommissionText = self.$t('sendmoney-more-commisions-text', { minamount:  txMinAmount, destination: tmpDestinationName })        
      },

      getHelpText(id, endId){
        const self = this
        const getHelpTextRespon = self.$api.staticData.getHelpTextById(id, endId);

        getHelpTextRespon.then(function(result) {
          if(result.length > 0){
            self.$store.state.transaction.paymentTime = result[0].content[0].value
          }
        })
      },

      getOnlineAdvisory(countryId,langId){
        const self = this
        const getOnlineAdvisoryResponse = self.$api.staticData.getOnlineAdvisory(countryId,langId);

        getOnlineAdvisoryResponse.then(function(result) {
          if (result.displayId == 1) {
            var modalContent = '<div class="display-flex justify-content-center  ml-lg"><img src='+require('@/assets/img/warning-email-failed.svg')+' style="height:100px" /></div><div class="pt-md text-align-center fs-14 fw-medium"> '+result.content+'</div>';
            self.openModal(modalContent);
            if(result.length > 0){
              // self.$store.state.transaction.paymentTime = result[0].content[0].value
            }

            /* QUICK FIX */
            /* TO OVERRIDE STYLE (COLOR) OF LINK THAT RETURNED FROM API */
            const linkCollection = document.getElementsByClassName("link");
            for (let i = 0; i < linkCollection.length; i++) {
              linkCollection[i].style.color = "var(--f7-button-text-color, var(--f7-theme-color))";
            }

            const elMenu = document.querySelector("div.menu");
            elMenu.style.position = "relative";
            elMenu.style.right = "auto";
            elMenu.style.bottom = "auto";
            /* END OF QUICK FIX */

          }
        })
      },

      getDeliveryTime(){
        const self = this
        var usedBankId       =  ( self.expressAvailable ) ? self.bankExpressId : self.bankId
        var usedBankBranchId = self.bankBranchId

        if(self.deliveryMethodId == 4){
          usedBankId       =  self.provinceId
          usedBankBranchId = self.cityId
        }

        const getDeliveryTimePromise = self.$api.beneficiary.getServiceId(usedBankId, usedBankBranchId, 0, self.deliveryMethodId) // FYI: pass country id == 0, to use correct query at ejb
        getDeliveryTimePromise.then(function(result) {
          self.deliveryTimeList = result
        })
      },

      populateDeliveryTime(){
        const self     = this
        const currDate = new Date()
        var dtResult   = self.deliveryTimeList

        if(dtResult != undefined && dtResult.serviceId != undefined){
          // VALIDATE FOR INDIA && DM BT, UPI , HOME AMOUNT > 100.000
          if(self.homeCountryId == 98 && (self.deliveryMethodId == 1 || self.deliveryMethodId == 9) && parseFloat(self.homeObj.amountReal) > 100000 ){
            self.deliveryTimei18n = ( currDate.getHours() >= 15 ) ? 'sendmoney-delivery-time-text-next-business-day' : 'sendmoney-delivery-time-text-business-day'
          }else if(self.homeCountryId == 167 && self.deliveryMethodId == 1){
            if( parseFloat(self.homeObj.amountReal) <= 50000){
              self.deliveryTimeNumber = 5
              self.deliveryTimei18n   = 'sendmoney-delivery-time-text-minutes'
            }else if( parseFloat(self.homeObj.amountReal) > 50000){
              self.deliveryTimeNumbe = 0
              if(self.bankId == 483 || self.bankId == 3	){
                self.deliveryTimei18n = ( currDate.getHours() <= parseInt(dtResult.cutOffTime.substring(0, 2)) ) ? 'sendmoney-delivery-time-text-business-day' : 'sendmoney-delivery-time-text-next-business-day'
              }else{
                self.deliveryTimei18n = 'sendmoney-delivery-time-text-next-business-day'
              }
            }
          }else{
            var deliveryType        = ( currDate.getHours() <= parseInt(dtResult.cutOffTime.substring(0, 2)) ) ? dtResult.estimatedDeliveryType : dtResult.newEstimatedDeliveryType
            self.deliveryTimeNumber = ( currDate.getHours() <= parseInt(dtResult.cutOffTime.substring(0, 2)) ) ? dtResult.estimatedDeliveryTime : dtResult.newEstimatedDeliveryTime

            if(deliveryType == "Business Days"){
              self.deliveryTimei18n = (self.deliveryTimeNumber == 1) ? 'sendmoney-delivery-time-text-next-business-day' : ( ( self.deliveryTimeNumber > 1) ? 'sendmoney-delivery-time-text-more-business-days' : 'sendmoney-delivery-time-text-business-day')
            }else{
              if(deliveryType == "Hours"){
                self.deliveryTimei18n = (self.deliveryTimeNumber > 1) ?  'sendmoney-delivery-time-text-hours' :  'sendmoney-delivery-time-text-hour'
              }else{
                self.deliveryTimei18n = 'sendmoney-delivery-time-text-minutes'
              }
            }

          }

        }
      },

      // BUTTON CONTINUE
      btnHandleSendMoneyEnterAmountContinue(){
        const self = this
        self.showPreloader();
        var transactionData = self.$store.state.transaction;

        transactionData.commissionAmount   = self.commissionAmount
        transactionData.paymentMethodId    = self.paymentMethodId
        transactionData.paymentMethod      = self.paymentMethod
        transactionData.totalAmountPayable = self.totalAmountPayable

        if( !(self.validatePaymentPurpose() && self.validatePaymentMethod() ) ){
            self.hidePreloader();
            return;
          }

        // UPDATE SETTLEMENT
        if(self.isMakePayment){
          transactionData.totalAmountSettlement = ( parseFloat(self.totalAmountPayable) + parseFloat(self.convenienceTotalFees))

          if(!window.Android && !window.webkit && self.paymentMethodId == 3) {
            self.checkWindow = window.open('/sendmoney-checkout?status=4', '_blank', "fullscreen=1");
            self.checkTimer = setInterval(function(){ if(self.checkWindow.closed) {self.checkoutCompleted(true);} }, 1000);
          }

          var updateSettlementParams = {
            "langCode"       : "EN",
            "retailBranchId" : self.$store.state.misc.appBranchId,
            "statusId"       : 1, // 1 for change payment method
            "payments"       : {
              "paymentList"  : [{
                "paymentMethodId" : self.paymentMethodId,
                "payable"         : self.totalAmountPayable,
                "fee"             : self.convenienceFee,
                "feeByPercentage" : self.convenienceFeeByPercentage,
                "totalPayable"    : ( parseFloat(self.totalAmountPayable) + parseFloat(self.convenienceTotalFees))
              }]
            }
          }

          const updateSettlement = self.$api.settlement.updateSettlement(self.settlementId, updateSettlementParams);
          updateSettlement.then(function(){
            if(self.paymentMethodId == 3) {
              self.checkoutCreditPayment()
            }else if(self.paymentMethodId == 14 || self.paymentMethodId == 2){
              self.hidePreloader();
              self.$f7router.navigate("/sendmoney/payment-detail")
            }else{
              self.hidePreloader();
              self.$f7router.navigate("/sendmoney/payment-summary")
            }
          });

        }else{
          self.couponErr.show = false
          transactionData.hostAmount                  = self.hostObj.amount;
          transactionData.homeAmount                  = self.homeObj.amount;
          transactionData.hostAmountReal              = self.hostObj.amountReal;
          transactionData.homeAmountReal              = self.homeObj.amountReal;
          transactionData.convenienceFee              = self.convenienceFee;
          transactionData.convenienceFeeByPercentage  = self.convenienceFeeByPercentage;
          transactionData.convenienceTotalFees        = self.convenienceTotalFees;

          transactionData.activeBidRate               = self.activeRate.bidRate;
          transactionData.bankExpressId               = self.bankExpressId;
          transactionData.couponCode                  = self.couponCode;
          transactionData.discountName                = self.discount.name;
          transactionData.discountAmount              = self.discount.amount;
          transactionData.discountDescription         = self.discount.description;
          transactionData.paymentPurposeId            = self.paymentPurposeId;
          transactionData.paymentPurpose              = self.paymentPurpose;
          transactionData.paymentPurposeOther         = self.paymentPurposeOther;

          self.$f7router.navigate("/sendmoney/confirmation");
          self.hidePreloader();
        }
      },

      // PAYMENT BY CREDIT SECTION....
      checkoutCreditPayment() {
        const self = this;
        this.$api.settlement.checkoutCreditPayment(self.settlementId).then(function(response) {
          if(response && response != undefined && response != '') {
            if(self.checkWindow !== undefined) {
              self.checkWindow.location.replace(response);
            } else {
              self.checkWindow = window.open(response, '_blank', "fullscreen=1");
            }
          } else {
            self.hidePreloader();
          }
        });
      },

      openModal(modalContent){
        const self = this;

        self.f7Method = {
          modal1: this.$f7.dialog.create({
            title: '',
            cssClass: 'single-button scrollable-dialog',
            text: modalContent,
            buttons : [{text: 'Dismiss', cssClass: 'ml-lg mr-lg mb-md', onClick: this.test}]
          }),

        };
        this.f7Method.modal1.open();
      },

      checkoutCompleted(navigateToNextPage) {
        this.hidePreloader();
        this.closePopupOnMobile();
        if(this.checkWindow !== undefined) {
          clearInterval(this.checkTimer);
          this.checkWindow.close();
          this.checkWindow = undefined;
        }
        if(navigateToNextPage) {
          this.$f7router.navigate("/sendmoney/payment-summary");
        }
      },

      handleBackButton(){
        this.$f7router.back({ transition: 'f7-push' })
      }

    }
  }
</script>